import React, {useContext, useState, useEffect} from 'react';
import {ShippingInstructionContext} from "./shipping-instruction-context";
import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    Grid,
    Paper,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    TextField,
} from "@mui/material";
import {DocumentTemplateService} from "../../services";
import _ from "underscore";
import IconButton from "@mui/material/IconButton";
import DeleteIcon from "@mui/icons-material/Delete";

function DocumentSection(props) {
    const {data, setData, methods, documentTemplates} = useContext(ShippingInstructionContext);
    const {ref} = methods;
    const [list, setList] = useState([]);
    const [open, setOpen] = useState(false);
    const [dirty, setDirty] = useState(false);

    
    useEffect(() => {
        if(dirty){
            props.checkIfDirty(dirty);
        }
    },[dirty]);
    
    const refreshDocumentList = (sectionId) => {
        const setIds = data.documents
            .filter(s => s.sectionId === sectionId)
            .map(s => s.parentDocumentTemplateId);
        const theList = documentTemplates.filter(s => !_.contains(setIds, s.id));
        setList(theList);
    }

    const findRow = (theDocument, member) => {
        let theRow = _.find(theDocument.documentMembers, {id: member.id});
        if (theRow === undefined) {
            theRow = _.find(theDocument.documentMembers, {documentId: member.documentId});
        }
        return theRow
    };

    const onOrdersChanged = (value, row, member) => {
        setDirty(true);
        const documents = data.documents.slice();
        let theDocument = _.find(documents, {
            parentDocumentTemplateId: row.parentDocumentTemplateId,
            sectionId: row.sectionId
        });
        let theRow = findRow(theDocument, member);
        theRow.documentOrder = value;
        setData({...data, documents: documents});
    }

    const onOriginalsChanged = (value, row, member) => {
        setDirty(true);
        const documents = data.documents.slice();
        let theDocument = _.find(documents, {
            parentDocumentTemplateId: row.parentDocumentTemplateId,
            sectionId: row.sectionId
        });
        let theRow = findRow(theDocument, member);
        theRow.numberOfOriginals = value;
        setData({...data, documents: documents});
    }

    const onCopiesChanged = (value, row, member) => {
        setDirty(true);
        const documents = data.documents.slice();
        let theDocument = _.find(documents, {
            parentDocumentTemplateId: row.parentDocumentTemplateId,
            sectionId: row.sectionId
        });
        let theRow = findRow(theDocument, member);
        theRow.numberOfCopies = value;
        setData({...data, documents: documents});
    }

    const removeDocumentSet = (row) => {
        setDirty(true);
        const documentData = data.documents.slice().filter(d => d.sectionId !== row.sectionId);
        const sectionDocuments = data.documents.slice().filter(d => d.sectionId === row.sectionId);
        const existingDocumentSet = sectionDocuments
            .filter(d => d.parentDocumentTemplateId !== row.parentDocumentTemplateId
                        );
       const documents =[...documentData, ...existingDocumentSet];
        setData({...data, documents: documents});
    };

    const removeRowMember = (row, member) => {
        setDirty(true);
        const documents = data.documents.slice();
        let theDocument = _.find(documents, {
            parentDocumentTemplateId: row.parentDocumentTemplateId,
            sectionId: row.sectionId
        });

        theDocument.documentMembers = theDocument.documentMembers.filter(obj => obj.documentId !== member.documentId);
        setData({...data, documents: documents});
    };

    const onDocumentAdd = ss => {
        setDirty(true);
        DocumentTemplateService
            .getById(ss.id)
            .then((response) => {
                var documents = data.documents.slice();
                documents.push({
                    parentDocumentTemplateId: ss.id,
                    templateName: response.data.templateName,
                    documentMembers: response.data.documentTemplateMembers
                        .map((m) => ({
                            documentId: m.document.id,
                            documentName: m.document.title,
                            numberOfCopies: m.defaultCopies,
                            numberOfOriginals: m.defaultOriginals,
                            documentOrder: m.defaultOrder
                        })),
                    sectionId: props.section.id
                });
                setData({...data, documents: documents});
                handleClose();
            });

    }

    const handleClose = () => {
        setOpen(false);
    }

    const handleOpen = (sectionId) => {
        refreshDocumentList(sectionId);
        setOpen(true);
    }


    return (
        <Grid>
            <Grid item xs={12}>
                {
                    (!props.section.countryDefaultSection || data.overrideCountryDefaults) &&
                    <Button color="primary" onClick={() => handleOpen(props.section.id)}>Add Document Sets</Button>
                }

                {
                    data.documents.filter(d => (d.sectionId === props.section.id)).length > 0 &&
                    <TableContainer component={Paper}>
                        <Table aria-label="simple table">
                            <TableHead>
                                <TableRow>
                                    <TableCell>Documents</TableCell>
                                    <TableCell>Order</TableCell>
                                    <TableCell>Originals</TableCell>
                                    <TableCell>Copies</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {
                                    data.documents.filter(d => (d.sectionId === props.section.id)).map((row, i) => (
                                        <>
                                            <TableRow key={'row-' + i}>
                                               
                                                <TableCell  style={{padding: 0, margin: 0, paddingLeft: 50, fontSize: 14, fontWeight: 'bold'}}>
                                                    {row.templateName}
                                                </TableCell>
                                                <TableCell
                                                    style={{padding: 0, paddingLeft: 5, margin: 0, maxWidth: '100px'}}
                                                    component="td"
                                                    scope="row">
                                                </TableCell>
                                                <TableCell
                                                    style={{padding: 0, paddingLeft: 5, margin: 0, maxWidth: '100px'}}
                                                    component="td"
                                                    scope="row">
                                                </TableCell>
                                                <TableCell
                                                    style={{padding: 0, paddingLeft: 5, margin: 0, maxWidth: '100px'}}
                                                    component="td"
                                                    scope="row">
                                                </TableCell>
                                                <TableCell style={{padding: 0, margin: 0, paddingLeft: 10}}>
                                                    <IconButton size="small" aria-label="delete"
                                                                onClick={() => removeDocumentSet(row)}>
                                                        <DeleteIcon color="error"/>
                                                    </IconButton>
                                                </TableCell>
                                            </TableRow>
                                            {row.documentMembers.map((member, index) => (
                                                <TableRow key={'member-' + index}>
                                                    <TableCell style={{padding: 0, paddingLeft: 50, margin: 0}}
                                                               component="td"
                                                               scope="row">
                                                        {member.documentName}
                                                    </TableCell>
                                                    <TableCell style={{
                                                        padding: 0,
                                                        margin: 0,
                                                        paddingLeft: 5,
                                                        maxWidth: '100px'
                                                    }}>
                                                        <TextField type="number" ref={ref} size="small"
                                                                   variant="outlined"
                                                                   value={member.documentOrder}
                                                                   onChange={(e) => onOrdersChanged(e.target.value, row, member)}
                                                        />
                                                    </TableCell>
                                                    <TableCell style={{
                                                        padding: 0,
                                                        margin: 0,
                                                        paddingLeft: 5,
                                                        maxWidth: '100px'
                                                    }}>
                                                        <TextField type="number" ref={ref} size="small"
                                                                   variant="outlined"
                                                                   value={member.numberOfOriginals}
                                                                   onChange={(e) => onOriginalsChanged(e.target.value, row, member)}
                                                        />
                                                    </TableCell>
                                                    <TableCell style={{
                                                        padding: 0,
                                                        margin: 0,
                                                        paddingLeft: 5,
                                                        maxWidth: '100px'
                                                    }}>
                                                        <TextField type="number" ref={ref} size="small"
                                                                   variant="outlined"
                                                                   value={member.numberOfCopies}
                                                                   onChange={(e) => onCopiesChanged(e.target.value, row, member)}
                                                        />
                                                    </TableCell>
                                                    <TableCell style={{padding: 0, margin: 0, paddingLeft: 10}}>
                                                        <IconButton size="small" aria-label="delete"
                                                                    onClick={() => removeRowMember(row, member)}>
                                                            <DeleteIcon color="error"/>
                                                        </IconButton>
                                                    </TableCell>
                                                </TableRow>))
                                            }
                                        </>
                                    ))
                                }

                            </TableBody>
                        </Table>
                    </TableContainer>
                }
            </Grid>

            <Dialog open={open} onClose={handleClose} aria-labelledby="form-dialog-title">
                <DialogTitle id="form-dialog-title">Add Document set</DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        Please add the Document set here.
                    </DialogContentText>

                    {list.length > 0 &&
                        <Grid>
                            <Grid item xs={12}>
                                <TableContainer component={Paper}>
                                    <Table aria-label="simple table">
                                        <TableHead>
                                            <TableRow>
                                                <TableCell>Document Set</TableCell>
                                                <TableCell>&nbsp;</TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {
                                                list.map((row, index) => (
                                                    <TableRow key={index}>
                                                        <TableCell style={{padding: 10, paddingLeft: 10, margin: 0}}
                                                                   component="td"
                                                                   scope="row">
                                                            {row.templateName}

                                                        </TableCell>
                                                        <TableCell style={{padding: 0, margin: 0, paddingLeft: 5}}>
                                                            <Button onClick={() => onDocumentAdd(row)}>Add</Button>
                                                        </TableCell>
                                                    </TableRow>))
                                            }
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            </Grid>
                        </Grid>
                    }
                    {
                        list.length === 0 &&
                        <>There is no document set that can be added to this shipping instruction.</>
                    }
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose} color="primary">
                        Close
                    </Button>
                </DialogActions>
            </Dialog>


        </Grid>
    );
}

export default DocumentSection;